import React from "react";
import { withTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { createUUID } from "../../assets/utils/Commons";
import PopConfirm from "../PopConfirm";
import CustomTooltip from "../Tooltip";
import { EditButton, DeleteButton } from "../Button";

const InlineAction = ({
  disableEdit,
  disableDelete,
  disablePermissionEdit,
  disablePermissionDelete,
  onEditClick,
  onDeleteClick,
  CustomerClick,
  t,
  id,
  autoCloseDelete,
  stopPropagationDelete
}) => {
  const onEditHandler = (e) => {
    e.preventDefault();
    onEditClick();
  };

  const onDeleteHandler = (e) => {
    onDeleteClick();
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-around",
        width: "100%",
      }}
    >
      {!disableEdit && (
        <EditButton onClick={onEditHandler} className="btn-hover-shine" disabled={disablePermissionEdit}/>
      )}
      {!disableDelete && (
        <PopConfirm
          id={id || createUUID()}
          onOK={onDeleteHandler}
          placement="bottom"
          type="danger"
          title={t("Warning")}
          content={t("Are you sure you want to delete?")}
          autoClose={autoCloseDelete}
        >
          <DeleteButton
            onClick={(e) => {
              if (stopPropagationDelete) {
                e.stopPropagation();
              }
            }}
            className="btn-hover-shine"
            disabled={disablePermissionDelete}
          />
        </PopConfirm>
      )}
      {CustomerClick && CustomerClick }
    </div>
  );
};

export default withTranslation(["dashboard"])(InlineAction);
